var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "filter__group row" },
    [
      _vm._l(_vm.filters, function (filter) {
        return [
          filter.type === _vm.constants.filterType.select
            ? [_c("sal-filter-select", { attrs: { filter: filter } })]
            : _vm._e(),
          _vm._v(" "),
          filter.type === _vm.constants.filterType.groupedselection
            ? [_c("sal-filter-groupedselect", { attrs: { filter: filter } })]
            : _vm._e(),
          _vm._v(" "),
          filter.type === _vm.constants.filterType.colors
            ? [_c("sal-filter-swatch", { attrs: { filter: filter } })]
            : _vm._e(),
          _vm._v(" "),
          filter.type === _vm.constants.filterType.button
            ? [_c("sal-filter-button", { attrs: { filter: filter } })]
            : _vm._e(),
          _vm._v(" "),
          filter.type === _vm.constants.filterType.checkboxes
            ? [_c("sal-filter-checkboxes", { attrs: { filter: filter } })]
            : _vm._e(),
          _vm._v(" "),
          filter.type === _vm.constants.filterType.checkbox
            ? [_c("sal-filter-checkbox", { attrs: { filter: filter } })]
            : _vm._e(),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }